define(
  'reviewsHandler',[
    'builderShowcaseObserver',
    'ajaxHelper',
    'routes',
    'fastdom',
    'reviewsParameters',
    'lazyLoad',
  ],
  (builderShowcaseObserver, ajaxHelper, routes, fastdom, reviewsParameters, lazyLoad) => {
    'use strict';

    const sortByList = document.querySelector('[data-component="sort-by-list"]');
    const reviewsSection = document.querySelector('[data-reviewsSection-container]');
    let lastMarketIdShowed = 0;

    /**
     * ReviewsHandler Constructor.
     */
    function ReviewsHandler() {
    }

    /**
     * calls lazy load init module
     * */
    function initLazyLoad() {
      if (lazyLoad) {
        lazyLoad.init();
      }
    }

    /**
    * @private
    * reviewsSkeleton: Display or removes the skeleton.
    * @param {object} showContent flag to display or hide.
   */
    function reviewsSkeleton(showContent) {
      const skeleton = document.getElementById('nhs_reviewsSkeleton');
      const reviewsCards = document.getElementById('nhs_reviewsCards');
      const filterArea = document.getElementById('FilterArea');

      if (skeleton) {
        if (showContent) {
          window.scrollTo({ top: filterArea ? filterArea.offsetTop : 200 });
          skeleton.style.display = 'block';
          reviewsCards.style.display = 'none';
        } else {
          skeleton.style.display = 'none';
          reviewsCards.style.display = 'block';
        }
      }
    }

    /**
     * @private
     * updateContent: sets the upcoming reviews section in the DOM.
     * @param {object} html Reviews section.
    */
    function updateContent(html, callback) {
      if (!reviewsSection) {
        return;
      }

      fastdom.mutate(() => {
        reviewsSection.innerHTML = html;
        if (typeof callback === 'function') {
          callback();
        }
      });

      fastdom.mutate(() => {
        initLazyLoad();
      });
    }

    /**
     * @private
     * getReviews: retrieves from api the reviews content.
     * @param {object} searchParams ratings&reviews api search params.
    */
    function getReviews(searchParams, callback) {
      const url = routes.getRatingsAndReviewsSection;

      ajaxHelper.postRequest(
        url,
        {
          data: searchParams,
          async: true,
          abort: true,
          requestHeaders: [
            {
              name: 'Content-Type',
              value: 'application/json'
            }
          ],
          success: (response) => {
            updateContent(response, callback);
            reviewsSkeleton(false);
          }
        }
      );
    }

    /**
    * @private
    * getReviews: retrieves from api the reviews content.
    * @param {object} searchParams ratings&reviews api search params.
    * @param {object} data new parameters.
    */
    function SetCommonParameters(searchParams, data) {
      const localSearchParams = searchParams;
      localSearchParams.BrandId = data.data.BrandId;
      localSearchParams.BuilderToSearch = data.data.brandName;
      localSearchParams.ReviewStar = data.data.ReviewSearchParams.ReviewStar;
      localSearchParams.ReviewSortBy = data.data.ReviewSearchParams.ReviewSortBy;
      localSearchParams.isReviewsPage = true;
      localSearchParams.PageSize = data.data.ReviewSearchParams.PageSize;
      localSearchParams.PageNumber = data.data.ReviewSearchParams.PageNumber;
      if (data.data.ReviewSearchParams.IsMarketSearch) {
        localSearchParams.MarketName = data.data.ReviewSearchParams.MarketName;
        localSearchParams.StateName = data.data.ReviewSearchParams.StateName;
        localSearchParams.MarketId = data.data.ReviewSearchParams.MarketId;
        localSearchParams.IsMarketSearch = data.data.ReviewSearchParams.IsMarketSearch;
        localSearchParams.StateAbbreviation = data.data.ReviewSearchParams.StateAbbreviation;
      }
      return localSearchParams;
    }

    /**
     * @private
     * onMarketChanged: Gets reviews based on the market update and update the reviews section.
     * @param {object} data buildershowcase state.
    */
    function onMarketChanged(data) {
      const proposedMarket = data.proposedMarket || {};

      if (proposedMarket.Id === lastMarketIdShowed) {
        return;
      }

      lastMarketIdShowed = proposedMarket.Id;

      const brandId = data.data.BrandId;
      const brandName = data.data.BrandName || '';
      const marketName = proposedMarket.Name || '';
      const marketId = +proposedMarket.Id || 0;
      const stateName = proposedMarket.StateName || '';
      const stateAbbreviation = proposedMarket.StateAbbr || '';
      const isMarketSearch = marketId && marketId > 0;
      const searchParams = reviewsParameters.getReviewsDefaultParameters();
      searchParams.BrandId = brandId;
      searchParams.StateName = stateName;
      searchParams.StateAbbreviation = stateAbbreviation;
      searchParams.MarketName = marketName;
      searchParams.MarketId = marketId;
      searchParams.IsMarketSearch = isMarketSearch;
      searchParams.BuilderToSearch = brandName;
      searchParams.PageSize = 2;

      /** TODO: show skeleton */
      getReviews(searchParams);
      /**  TODO: hide skeleton */
    }

    /**
     * @private
     * onSortByChanged: Gets reviews based on the sort by.
     * @param {object} data buildershowcase state.
    */
    function onSortByChanged(data) {
      let sortBy = data.searchParameters.ReviewSortBy;

      if (!sortBy) {
        sortBy = sortByList[sortByList.selectedIndex];
      }

      let searchParams = reviewsParameters.getReviewsDefaultParameters();
      searchParams = SetCommonParameters(searchParams, data);
      searchParams.ReviewSortBy = sortBy;
      searchParams.PageNumber = 1;
      searchParams.isReviewsPage = true;
      reviewsSkeleton(true);
      getReviews(searchParams, () => {
        builderShowcaseObserver.onReviewsSectionLoaded(data);
      });
    }

    /**
     * @private
     * onSortByChanged: Gets reviews based on the star filter.
     * @param {object} data buildershowcase state.
    */
    function onStarFilterChanged(data) {
      let searchParams = reviewsParameters.getReviewsDefaultParameters();
      searchParams = SetCommonParameters(searchParams, data);
      searchParams.isReviewsPage = true;
      searchParams.PageNumber = 1;
      reviewsSkeleton(true);
      getReviews(searchParams, () => {
        builderShowcaseObserver.onReviewsSectionLoaded(data);
      });
    }

    /**
     * @private
     * onSortByChanged: Gets reviews based on the star filter.
     * @param {object} data buildershowcase state.
    */
    function PaginationChanged(data) {
      let searchParams = reviewsParameters.getReviewsDefaultParameters();
      searchParams = SetCommonParameters(searchParams, data);
      searchParams.isReviewsPage = true;
      reviewsSkeleton(true);
      getReviews(searchParams, () => {
        builderShowcaseObserver.onReviewsSectionLoaded(data);
      });
    }

    /**
     * @private
     * onSortByChanged: Gets reviews based on pageSize.
     * @param {object} data buildershowcase state.
    */
    function PageSizeChanged(data) {
      let searchParams = reviewsParameters.getReviewsDefaultParameters();
      searchParams = SetCommonParameters(searchParams, data);
      searchParams.isReviewsPage = true;
      searchParams.PageNumber = 1;
      reviewsSkeleton(true);
      getReviews(searchParams, () => {
        builderShowcaseObserver.onReviewsSectionLoaded(data);
      });
    }

    /**
     * @public
     * update: function for receiving notifications about state changes.
     * @param {object} data buildershowcase state.
    */
    ReviewsHandler.update = function updateReviewsSection(data) {
      switch (data.filterType) {
        case 'sortBy':
          onSortByChanged(data);
          break;
        case 'starFilter':
          onStarFilterChanged(data);
          break;
        case 'pagination':
          PaginationChanged(data);
          break;
        case 'pageSize':
          PageSizeChanged(data);
          break;
        default:
          onMarketChanged(data);
      }
    };

    builderShowcaseObserver.subscribe('onBeforeMapResultsLoaded', ReviewsHandler);
    builderShowcaseObserver.subscribe('OnSortByChanged', ReviewsHandler);
    builderShowcaseObserver.subscribe('OnPageSizeChanged', ReviewsHandler);
    builderShowcaseObserver.subscribe('OnStarFilterChanged', ReviewsHandler);
    builderShowcaseObserver.subscribe('PaginationChanged', ReviewsHandler);

    initLazyLoad();
  }
);

